/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  AccountSetSessionAction,
  SET_ACCOUNT_SESSION,
  AccountSession,
  CLEAR_SESSION,
  ClearSession,
  GetLanguage,
  GET_LANGUAGE,
} from './types';

export const onSetAccountSession = (payload: AccountSession): AccountSetSessionAction => ({
  type: SET_ACCOUNT_SESSION,
  payload,
});

export const onClearSession = (): ClearSession => ({
  type: CLEAR_SESSION,
});

export const onGetlanguage = (payload: any | undefined): GetLanguage => ({
  type: GET_LANGUAGE,
  payload,
});
